import { faker } from "@faker-js/faker/locale/fr"
import { SourceName } from "../../../types"
import type { ApiFinancialDataActivity } from "../../activity/financialDataActivity.model"

const float = () => faker.number.float({ min: 0, max: 999_999, fractionDigits: 2 })
const fakeDate = () => faker.date.recent({ days: 365 }).toISOString().split("T")[0]
const maybe = <T>(val: T) => faker.helpers.maybe(() => val, { probability: 0.8 })

const keyFigureWithUpp = () => ({
  mainStat: maybe(float()) ?? null,
  evolution:
    maybe(faker.number.float({ min: -100, max: 200, fractionDigits: 2 })) ?? null,
  upp: maybe({
    mainStat: maybe(float()) ?? null,
    evolution:
      maybe(faker.number.float({ min: -100, max: 200, fractionDigits: 2 })) ?? null,
  }),
})

export const activityMock = (): ApiFinancialDataActivity => ({
  pharmacyId: faker.number.int({ min: 0, max: 9_999_999_999 }),
  sources: [SourceName.SANTESTAT],
  periodStartDate: fakeDate(),
  periodEndDate: fakeDate(),
  weeklyAttendance: maybe(keyFigureWithUpp()),
  averageBasket: maybe(keyFigureWithUpp()),
  averageBasketWithoutPrescription: maybe(keyFigureWithUpp()),
})
